(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/views/person-data.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/views/person-data.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.terms_integrity.views.PersonData = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.terms_integrity.templates.person_data(data);
    },
    tagName: 'div',
    id: 'personData',
    className: 'bg-white',
    modelEvents: {
      change: 'render'
    },
    ui: {},
    events: {}
  });
})(Backbone, svs);

 })(window);